export const CGAFileType = {
    '1': 'Committee',
    '2': 'Senate',
    '3': 'House',
};